import Vue from 'vue'
import Router from 'vue-router'
import {uploadAction} from "../main";
import App from "../App";

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'homeIndex',
            meta:{
                title: '',
                id: 1,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "homeIndex" */ '@/pages/index.vue')
        },
        {
			path: '/index',
			name: 'homeIndex',
            meta:{
                title: '',
                id: 1,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "homeIndex" */ '@/pages/index.vue')
        },
        {
			path: '/u8',
			name: 'u8',
            meta:{
                title: '',
                id: 11,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "u8" */ '@/pages/yongyou/u8.vue')
        },
        {
			path: '/u9',
			name: 'u9',
            meta:{
                title: '',
                id: 12,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "u8" */ '@/pages/yongyou/u9.vue')
        },
        {
			path: '/nc',
			name: 'nc',
            meta:{
                title: '',
                id: 13,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "nc" */ '@/pages/yongyou/nc.vue')
        },
        {
			path: '/bip',
			name: 'bip',
            meta:{
                title: '',
                id: 14,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "bip" */ '@/pages/yongyou/bip.vue')
        },
        {
			path: '/ys',
			name: 'ys',
            meta:{
                title: '',
                id: 15,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "ys" */ '@/pages/yongyou/ys.vue')
        },
        {
			path: '/erp',
			name: 'erp',
            meta:{
                title: '',
                id: 16,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "erp" */ '@/pages/yongyou/erp.vue')
        },
        {
			path: '/zjtx',
			name: 'zjtx',
            meta:{
                title:"专精特新"
            },
			component: () => import( /* webpackChunkName: "zjtx" */ '@/pages/erp/zjtx.vue')
        },
        {
			path: '/crm',
			name: 'crm',
            meta:{
                title: '',
                id: 17,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "crm" */ '@/pages/yongyou/crm.vue')
        },
        {
			path: '/plm',
			name: 'plm',
            meta:{
                title: '',
                id: 18,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "plm" */ '@/pages/yongyou/plm.vue')
        },
        // {
        //     path: '/yonbulider',
        //     name: 'yonbulider',
        //     component: () => import( /* webpackChunkName: "yonbulider" */ '@/pages/yongyou/yonbulider.vue')
        // },
        {
			path: '/bill',
			name: 'bill',
            meta:{
                title: '',
                id: 20,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "bill" */ '@/pages/yongyou/bill.vue')
        },
        {
			path: '/money',
			name: 'money',
            meta:{
                title: '',
                id: 21,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "money" */ '@/pages/yongyou/money.vue')
        },
        {
			path: '/zl',
			name: 'zl',
            meta:{
                title:"yongyou"
            },
			component: () => import( /* webpackChunkName: "zl" */ '@/pages/yongyou/zl.vue')
        },
        {
			path: '/zncw',
			name: 'zncw',
            meta:{
                title: '',
                id: 59,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zncw" */ '@/pages/chengzhangyun/zncw.vue')
        },
        {
			path: '/szrl',
			name: 'szrl',
            meta:{
                title: '',
                id: 60,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szrl" */ '@/pages/chengzhangyun/szrl.vue')
        },
        {
			path: '/zhcg',
			name: 'zhcg',
            meta:{
                title: '',
                id: 62,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zhcg" */ '@/pages/chengzhangyun/zhcg.vue')
        },
        {
			path: '/szzc',
			name: 'szzc',
            meta:{
                title: '',
                id: 74,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szzc" */ '@/pages/chengzhangyun/szzc.vue')
        },
        {
			path: '/mjgy',
			name: 'mjgy',
            meta:{
                title: '',
                id: 75,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "mjgy" */ '@/pages/chengzhangyun/mjgy.vue')
        },
        {
			path: '/szyx',
			name: 'szyx',
            meta:{
                title: '',
                id: 76,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szyx" */ '@/pages/chengzhangyun/szyx.vue')
        },
        {
			path: '/szxm',
			name: 'szxm',
            meta:{
                title: '',
                id: 38,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szxm" */ '@/pages/chengzhangyun/szxm.vue')
        },
        {
			path: '/zhxt',
			name: 'zhxt',
            meta:{
                title: '',
                id: 41,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zhxt" */ '@/pages/chengzhangyun/zhxt.vue')
        },
        {
			path: '/hgsw',
			name: 'hgsw',
            meta:{
                title: '',
                id: 79,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "hgsw" */ '@/pages/chengzhangyun/hgsw.vue')
        },
        {
			path: '/znzz',
			name: 'znzz',
            meta:{
                title: '',
                id: 80,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "znzz" */ '@/pages/chengzhangyun/znzz.vue')
        },
        {
			path: '/szcz',
			name: 'szcz',
            meta:{
                title: '',
                id: 81,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szcz" */ '@/pages/chengzhangyun/szcz.vue')
        },
        {
			path: '/xmgl',
			name: 'xmgl',
            meta:{
                title: '',
                id: 87,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "xmgl" */ '@/pages/chengzhangyun/xmgl.vue')
        },
        {
			path: '/szpt',
			name: 'szpt',
            meta:{
                title: '',
                id: 82,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szpt" */ '@/pages/chengzhangyun/szpt.vue')
        },
        {
			path: '/zyfwhy',
			name: 'zyfwhy',
            meta:{
                title: '',
                id: 83,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zyfwhy" */ '@/pages/chengzhangyun/zyfwhy.vue')
        },
        {
			path: '/yylt',
			name: 'yylt',
            meta:{
                title: '',
                id: 84,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "yylt" */ '@/pages/chengzhangyun/yylt.vue')
        },
        {
			path: '/lshy',
			name: 'lshy',
            meta:{
                title: '',
                id: 85,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "lshy" */ '@/pages/chengzhangyun/lshy.vue')
        },
        {
			path: '/c_crm',
			name: 'c_crm',
            meta:{
                title: '',
                id: 17,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "c_crm" */ '@/pages/chengzhangyun/crm.vue')
        },
        {
			path: '/szzz',
			name: 'szzz',
            meta:{
                title: '',
                id: 90,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szzz" */ '@/pages/erp/szzz.vue')
        },
        {
			path: '/jxcb',
			name: 'jxcb',
            meta:{
                title: '',
                id: 92,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "jxcb" */ '@/pages/erp/jxcb.vue')
        },
        {
			path: '/sjzz',
			name: 'sjzz',
            meta:{
                title: '',
                id: 93,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "sjzz" */ '@/pages/erp/sjzz.vue')
        },
        {
			path: '/xmzz',
			name: 'xmzz',
            meta:{
                title: '',
                id: 94,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "xmzz" */ '@/pages/erp/xmzz.vue')
        },
        {
			path: '/wlhxt',
			name: 'wlhxt',
            meta:{
                title: '',
                id: 95,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "wlhxt" */ '@/pages/erp/wlhxt.vue')
        },
        {
			path: '/gxhdz',
			name: 'gxhdz',
            meta:{
                title: '',
                id: 96,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "gxhdz" */ '@/pages/erp/gxhdz.vue')
        },
        {
			path: '/zzfw',
			name: 'zzfw',
            meta:{
                title: '',
                id: 97,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zzfw" */ '@/pages/erp/zzfw.vue')
        },
        {
			path: '/amb',
			name: 'amb',
            meta:{
                title:"阿米巴责任考核"
            },
			component: () => import( /* webpackChunkName: "amb" */ '@/pages/erp/amb.vue')
        },
        {
			path: '/jygl',
			name: 'jygl',
            meta:{
                title: '',
                id: 98,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "jygl" */ '@/pages/erp/jygl.vue')
        },
        {
			path: '/zngc',
			name: 'zngc',
            meta:{
                title: '',
                id: 100,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zngc" */ '@/pages/erp/zngc.vue')
        },
        {
			path: '/cwzn',
			name: 'cwzn',
            meta:{
                title:"yongyou",
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "cwzn" */ '@/pages/czxqy/cwzn.vue')
        },
        {
			path: '/c_szrl',
			name: 'szrl',
            meta:{
                title: '',
                id: 35,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szrl" */ '@/pages/czxqy/szrl.vue')
        },
        {
			path: '/mjgyl',
			name: 'mjgyl',
            meta:{
                title: '',
                id: 36,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "mjgyl" */ '@/pages/czxqy/mjgyl.vue')
        },
        {
			path: '/szpt2',
			name: 'szpt2',
            meta:{
                title: '',
                id: 67,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szpt2" */ '@/pages/czxqy/szpt2.vue')
        },
        {
			path: '/c_zncw',
			name: 'c_zncw',
            meta:{
                title: '',
                id: 71,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "c_zncw" */ '@/pages/czxqy/zncw.vue')
        },
        {
			path: '/c_zhcg',
			name: 'c_zhcg',
            meta:{
                title: '',
                id: 73,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zhcg" */ '@/pages/czxqy/zhcg.vue')
        },
        {
			path: '/c_znzz',
			name: 'c_znzz',
            meta:{
                title: '',
                id: 63,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "znzz" */ '@/pages/czxqy/znzz.vue')
        },
        {
			path: '/qyjr',
			name: 'qyjr',
            meta:{
                title: '',
                id: 64,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "qyjr" */ '@/pages/czxqy/qyjr.vue')
        },
        {
			path: '/c_szpt',
			name: 'c_szpt',
            meta:{
                title: '',
                id: 67,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szpt" */ '@/pages/czxqy/szpt.vue')
        },
        {
			path: '/xtbg',
			name: 'xtbg',
            meta:{
                title: '',
                id: 66,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "xtbg" */ '@/pages/czxqy/xtbg.vue')
        },
        {
			path: '/cwy',
			name: 'cwy',
            meta:{
                title: '',
                id: 46,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "cwy" */ '@/pages/lyy/cwy.vue')
        },
        {
			path: '/rly',
			name: 'rly',
            meta:{
                title: '',
                id: 47,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "rly" */ '@/pages/lyy/rly.vue')
        },
        {
			path: '/xty',
			name: 'xty',
            meta:{
                title: '',
                id: 48,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "xty" */ '@/pages/lyy/xty.vue')
        },
        {
			path: '/yxy',
			name: 'yxy',
            meta:{
                title: '',
                id: 49,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "yxy" */ '@/pages/lyy/yxy.vue')
        },
        {
			path: '/cgy',
			name: 'cgy',
            meta:{
                title: '',
                id: 50,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "cgy" */ '@/pages/lyy/cgy.vue')
        },
        {
			path: '/zzy',
			name: 'zzy',
            meta:{
                title: '制造云',
                id: 100,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zzy" */ '@/pages/lyy/zzy.vue')
        },
        {
			path: '/gyl',
			name: 'gyl',
            meta:{
                title: '',
                id: 51,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "gyl" */ '@/pages/lyy/gyl.vue')
        },
        {
			path: '/zcy',
			name: 'zcy',
            meta:{
                title: '',
                id: 52,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "zcy" */ '@/pages/lyy/zcy.vue')
        },
        {
			path: '/czy',
			name: 'czy',
            meta:{
                title: '',
                id: 53,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "czy" */ '@/pages/lyy/czy.vue')
        },
        {
			path: '/jzy',
			name: 'jzy',
            meta:{
                title: '',
                id: 54,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "jzy" */ '@/pages/lyy/jzy.vue')
        },
        {
			path: '/swy',
			name: 'swy',
            meta:{
                title: '',
                id: 55,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "swy" */ '@/pages/lyy/swy.vue')
        },
        {
			path: '/szcw',
			name: 'szcw',
            meta:{
                title: '',
                id: 34,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "szcw" */ '@/pages/yonsuite/szcw.vue')
        },
        {
			path: '/y_szrl',
			name: 'y_szrl',
            meta:{
                title: '',
                id: 35,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_szrl" */ '@/pages/yonsuite/szrl.vue')
        },
        {
			path: '/mjgyl',
			name: 'mjgyl',
            meta:{
                title: '',
                id: 36,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "mjgyl" */ '@/pages/yonsuite/mjgyl.vue')
        },
        {
			path: '/y_zhcg',
			name: 'y_zhcg',
            meta:{
                title: '',
                id: 37,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_zhcg" */ '@/pages/yonsuite/zhcg.vue')
        },
        {
			path: '/y_szyx',
			name: 'y_szyx',
            meta:{
                title: '',
                id: 44,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_szyx" */ '@/pages/yonsuite/szyx.vue')
        },
        {
			path: '/y_szzc',
			name: 'y_szzc',
            meta:{
                title: '',
                id: 42,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_szzc" */ '@/pages/yonsuite/szzc.vue')
        },
        {
			path: '/y_szxm',
			name: 'y_szxm',
            meta:{
                title: '',
                id: 38,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_szxm" */ '@/pages/yonsuite/szxm.vue')
        },
        {
			path: '/y_zhxt',
			name: 'y_zhxt',
            meta:{
                title: '',
                id: 41,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_zhxt" */ '@/pages/yonsuite/zhxt.vue')
        },
        {
			path: '/y_hgsw',
			name: 'y_hgsw',
            meta:{
                title: '',
                id: 79,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_hgsw" */ '@/pages/yonsuite/hgsw.vue')
        },
        {
			path: '/y_szcz',
			name: 'y_szcz',
            meta:{
                title: '',
                id: 81,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_szcz" */ '@/pages/yonsuite/szcz.vue')
        },
        {
			path: '/y_znzz',
			name: 'y_znzz',
            meta:{
                title: '',
                id: 80,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "y_znzz" */ '@/pages/yonsuite/znzz.vue')
        },
        {
			path: '/qyfy',
			name: 'qyfy',
            meta:{
                title: '',
                id: 28,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "qyfy" */ '@/pages/yonsuite/qyfy.vue')
        },
        {
			path: '/qmsz',
			name: 'qmsz',
            meta:{
                title: '',
                id: 40,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "qmsz" */ '@/pages/yonsuite/qmsz.vue')
        },
        {
			path: '/a6',
			name: 'a6',
            meta:{
                title: '',
                id: 23,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "a6" */ '@/pages/xtrj/a6.vue')
        },
        {
			path: '/we',
			name: 'we',
            meta:{
                title: '',
                id: 6,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "we" */ '@/pages/we.vue')
        },
        {
			path: '/dt',
			name: 'dt',
            meta:{
                title: '',
                id: 5,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "dt" */ '@/pages/dt.vue')
        },
        {
            path: '/info',
            name: 'info',
            meta:{
                title:"详情",
                content: {
                    keywords: '',
                    description: ''
                }
            },
            component: () => import( /* webpackChunkName: "info" */ '@/pages/info.vue')
        },
        {
			path: '/al',
			name: 'al',
            meta:{
                title: '',
                id: 4,
                content: {
                    keywords: '',
                    description: ''
                }
            },
			component: () => import( /* webpackChunkName: "al" */ '@/pages/al.vue')
        },
	]

})





// WEBPACK FOOTER //
// ./src/router/index.js